import { Component, Input, OnInit } from '@angular/core';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctors-next-unblock',
  templateUrl: './doctors-next-unblock.component.html',
  styleUrls: [
    './doctors-next-unblock.component.css',
    '../style/index.css',
    '../style/verification-page.css',
  ],
})
export class DoctorsNextUnblockComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }
}
